import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import Button from '@shared/Button';

import HitDetailsMore from './HitDetailsMore';
import ListWidget from './ListWidget';
import RecallExplanation from "./RecallExplanation"
import RuleWidget from './RuleWidget';
import SanctionsDetails from './SanctionsDetails';
import ThresholdWidget from './ThresholdWidget';

const ExpandBtn = styled(Button)`
  background-color: ${props => props.theme.enigmaWhite};
  border-radius: 20px auto;
  border: 1px solid ${props => props.theme.primary};
  color: ${props => props.theme.primary};
  display: inline-block;
  font-family: 'GT Mono', monospace;
  font-size: 12px;
  margin-top: 20px;
  text-transform: uppercase;
  &:hover {
    background-color: ${props => props.theme.primary};
    color: ${props => props.theme.enigmaWhite};
    border: 1px solid ${props => props.theme.primary};
  }
`;

function HitDetails({ alertId, hitId, decision, explanation, recall_explanation, sanctionedEntityDetails, listMetadata }) {
  const [expanded, setExpanded] = useState(false);
  const onClickBtn = e => {
    e.preventDefault();
    setExpanded(!expanded);
  };

  const { override = {}, model = {}, threshold = {} } = explanation;

  let isRuleBased = false;
  let isModelBased = false;
  let isThresholdBased = false;
  if (
    (decision === 1 && override.decision === 1) ||
    (decision === 0 && (model.decision === 1 || threshold.decision === 1))
  ) {
    isRuleBased = true;
  } else if (decision === 1 && model.decision === 1) {
    isModelBased = true;
  } else if (decision === 1 && threshold.decision === 1) {
    isThresholdBased = true;
  } else {
    // what is default case? Is there by definition, no hit that doesn't qualify in at least some way?
    isModelBased = true;
  }

  return (
    <div>
      <ListWidget {...listMetadata} />
      {isModelBased && (
        <ThresholdWidget value={model.score} thresholdValue={model.threshold} />
      )}
      {isThresholdBased && (
        <ThresholdWidget
          value={threshold.score}
          thresholdValue={threshold.minimum_score}
        />
      )}
      <SanctionsDetails {...sanctionedEntityDetails} />
      <RecallExplanation recall_explanation={recall_explanation}/>
      {isRuleBased && <RuleWidget type={override.type} />}
     <div> <ExpandBtn onClick={onClickBtn}>
             {expanded ? 'Hide' : 'Show'} Decision Explanation
           </ExpandBtn></div>
      {expanded && (
        <HitDetailsMore
          isModelBased={isModelBased}
          isThresholdBased={isThresholdBased}
          isRuleBased={isRuleBased}
          alertId={alertId}
          hitId={hitId}
        />
      )}
    </div>
  );
}

HitDetails.propTypes = {
  alertId: PropTypes.string.isRequired,
  decision: PropTypes.number.isRequired,
  hitId: PropTypes.number.isRequired,
  explanation: PropTypes.shape({
    override: PropTypes.shape({
      decision: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }),
    model: PropTypes.shape({
      decision: PropTypes.number.isRequired,
      score: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }),
    threshold: PropTypes.shape({
      type: PropTypes.string.isRequired,
      decision: PropTypes.number.isRequired,
      minimum_score: PropTypes.number.isRequired,
      score: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default HitDetails;
